export function updateAndClone(arr, index, val) {
    const result = [...arr];
    result[Number(index)] = val;
    return result;
}
export const inputSizeClass = {
    auto: '',
    small: '',
    medium: '--m',
    large: '--l', // max 11 digit display
};
export const getGroups = (num) => {
    const { 0: main, 1: decimal } = num.toString().split('.');
    return { main, decimal };
};
export function evaluateInputSize(range, format, step, prefixLabel, suffixLabel) {
    const digits = getGroups(range.max).main.length;
    const decimals = step % 1 !== 0 ? (getGroups(step).decimal || '').length : 0;
    const formattedMaxLength = Math.max(format.to(range.max).length, format.to(range.min).length, format.to(range.max + step).length);
    let metaLength = 0;
    if (prefixLabel.length)
        metaLength += prefixLabel.length + 1; // +1 for prefix margin
    if (suffixLabel.length)
        metaLength += suffixLabel.length + 1; // +1 for suffix margin
    const total = Math.max(digits + decimals, formattedMaxLength) + metaLength;
    let result = 'large';
    if (total < 7)
        result = 'small';
    else if (total < 9)
        result = 'medium';
    return result;
}
